namespace GeniuzPOS.ReportMasterData {
    export interface Report_1410Row {
        Id?: string;
        DocDate?: string;
        MbId?: string;
        MbNameT?: string;
        GrossSales?: number;
        AllItemDiscount?: number;
        NetSales?: number;
        NetSalesExVat?: number;
        VatOfNetSales?: number;
        AllItemCharge?: number;
        VatOfCharge?: number;
        FullName1?: string;
    }

    export namespace Report_1410Row {
        export const idProperty = 'Id';
        export const nameProperty = 'Id';
        export const localTextPrefix = 'ReportMasterData.Report_1410';
        export const deletePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:ยอดขายรวมร้านค้า:View';
        export const insertPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:ยอดขายรวมร้านค้า:View';
        export const readPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:ยอดขายรวมร้านค้า:View';
        export const updatePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:ยอดขายรวมร้านค้า:View';

        export declare const enum Fields {
            Id = "Id",
            DocDate = "DocDate",
            MbId = "MbId",
            MbNameT = "MbNameT",
            GrossSales = "GrossSales",
            AllItemDiscount = "AllItemDiscount",
            NetSales = "NetSales",
            NetSalesExVat = "NetSalesExVat",
            VatOfNetSales = "VatOfNetSales",
            AllItemCharge = "AllItemCharge",
            VatOfCharge = "VatOfCharge",
            FullName1 = "FullName1"
        }
    }
}
